import React, { forwardRef, useContext } from "react";

import { DataProviderContext } from "src/core/provider/dataProvider";
import { CandidateMode } from "src/utils/api/configD";

/**
 * Hides the wrapped component when the
 * application is not in Edit (candidate) mode.
 */
export const withEditModeGuard = <P extends object>(
  WrappedComponent: React.ComponentType<P>
) => {
  const Guarded = forwardRef<unknown, P>((props, ref) => {
    const { mode } = useContext(DataProviderContext);

    if (mode !== CandidateMode.Edit) {
      return null;
    }

    return <WrappedComponent {...props} ref={ref} />;
  });

  Guarded.displayName = `withEditModeGuard(${
    WrappedComponent.displayName ?? WrappedComponent.name ?? "Component"
  })`;

  return Guarded;
};
